import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppVersion {
  /** Set by `npm run release` (see the README) */
  version: string;
  /** The git commit the server runs, when it knows */
  commit: string | null;
}

/** Which version of the app the server runs, asked once when the app starts; shown in the account menu */
@Injectable({ providedIn: 'root' })
export class VersionService {
  private http = inject(HttpClient);
  readonly current = signal<AppVersion | null>(null);

  async load(): Promise<void> {
    try {
      this.current.set(await firstValueFrom(this.http.get<AppVersion>('/api/version')));
    } catch {
      // Not known: the menu leaves it out
    }
  }
}
